import ProfileService from '../services/profile.service';
import { LOAD_APP_DATA } from './global.actions.types';
import {
  PURGE_APP_DATA,
  SET_LOADING,
  SET_APP_DATA,
  SET_ERROR,
  SWITCH_GOD_MODE,
} from './global.mutations.types';

const state = {
  appReady: false,
  loading: false,
  user: null,
  roles: null,
  userRole: null,
  error: null,
  isGod: false,
};

const getters = {};

const mutations = {
  [SWITCH_GOD_MODE](state) {
    state.isGod = !state.isGod;
  },
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_LOADING](state, flag) {
    state.loading = flag;
  },
  [SET_APP_DATA](state, appData) {
    const { user } = appData;
    state.user = user;
    state.appReady = true;
  },
  [PURGE_APP_DATA](state) {
    state.appReady = false;
    state.user = null;
    state.roles = null;
    state.userRole = null;
  },
};

const actions = {
  async [LOAD_APP_DATA](context) {
    const profilingData = await ProfileService.loadProfilingData();
    context.commit(SET_APP_DATA, profilingData);
  },
  async [SET_ERROR]({ commit }, error) {
    commit(SET_ERROR, error);
  },
  async [SWITCH_GOD_MODE]({ commit }) {
    commit(SWITCH_GOD_MODE);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
